import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";
import {useEffect} from "react";

interface ResponseTypes {
	list: any[];
	total: number;
}

const M_KEY = '/advertiser/ad/list' // 광고목록 조회

const fetchKey = (page, maxData, status, order) =>
	`${M_KEY}?${page && 'page=' + page}${maxData && '&maxData=' + maxData}${status > 0 ? '&status=' + status : ''}${order && '&order=' + order}`;

export function useAdvertiserADList(page, maxData, status, order) {
	const { data: token } = useToken();

	const KEY = fetchKey(page, maxData, status, order);


	const fetcher = () => fetchAPI(KEY, token);
	const { data, mutate, isLoading } = useSWR(token ? `${KEY}` : null, fetcher, { revalidateOnFocus: true });

	return { advertiserADList: data?.list, mutateAdvertiserADList: mutate, total: data?.total, isLoading };
}

async function fetchAPI(KEY:string, token:any): Promise<ResponseTypes> {
	try {
		const response = await API.get(`${KEY}`, token + '', {});
		return {list: response.result?.result?.list || [], total: response.result?.result?.totalCount}
	} catch (error) {
		console.error('Failed to fetch Advertiser AD List:', error);
		return { list: [], total: 0 };
	}
}